const PAYMENT_LINK_METHOD = 1;
const PAYMENT_RECURRING_METHOD = 2;
const PAYMENT_CARD_METHOD = 3;

export { PAYMENT_CARD_METHOD, PAYMENT_LINK_METHOD, PAYMENT_RECURRING_METHOD };
